// Recovered compiled webpack factory 60057. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { BY: () => s, EU: () => o, Se: () => i });
  var n = r(81259),
    a = r(49636);
  function o() {
    return (i(a.O), a.O);
  }
  function i(e) {
    let t = (e.__SENTRY__ = e.__SENTRY__ || {});
    return ((t.version = t.version || n.M), (t[n.M] = t[n.M] || {}));
  }
  function s(e, t, r = a.O) {
    let o = (r.__SENTRY__ = r.__SENTRY__ || {}),
      i = (o[n.M] = o[n.M] || {});
    return i[e] || (i[e] = t());
  }
}
